// const BASE_URL = "http://192.168.10.39:4000/api/v1";
// const BASE_URL = "http://localhost:4000/api/v1";
const BASE_URL = "https://backend-kodevedic.vercel.app/api/v1";



// AUTH ENDPOINTS
export const endpoints = {
  SENDOTP_API: BASE_URL + "/auth/sendotp",
  SIGNUP_API: BASE_URL + "/auth/signup",
  LOGIN_API: BASE_URL + "/auth/login",
  RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
  RESETPASSWORD_API: BASE_URL + "/auth/reset-password",
};

// PROFILE ENDPOINTS
export const profileEndpoints = {
  GET_USER_DETAILS_API: BASE_URL + "/profile/getUserDetails",
  GET_USER_ENROLLED_COURSES_API: BASE_URL + "/profile/getEnrolledCourses",
  GET_INSTRUCTOR_DATA_API: BASE_URL + "/profile/instructorDashboard",
};
 
// STUDENTS ENDPOINTS
export const studentEndpoints = {
  COURSE_PAYMENT_API: BASE_URL + "/payment/capturePayment",
  COURSE_VERIFY_API: BASE_URL + "/payment/verifyPayment",
  SEND_PAYMENT_SUCCESS_EMAIL_API: BASE_URL + "/payment/sendPaymentSuccessEmail",
};

//ADMIN ENDPOINTS
export const adminEndpoints = {
  CREATE_CATEGORY_API: BASE_URL + "/admin/createCategory",
  UPDATE_CATEGORY_API: BASE_URL + "/admin/updateCategory",
  DELETE_CATEGORY_API: BASE_URL + "/admin/deleteCategory",
  GET_ALL_CATEGORIES_API: BASE_URL + "/admin/getAllCategories",
  SHOW_ALL_CATEGORIES: BASE_URL + "/showAllCategories",
  GET_CATEGORY_PAGE_DETAILS: BASE_URL + "/getCategoryPageDetails",
  GET_ALL_INSTRUCTOR_DETAILS: BASE_URL + "/admin/getAllInstructorDetails",
  GET_ALL_STUDENT_DETAILS: BASE_URL + "/admin/getAllStudentDetails",
  GET_ALL_COURSE: BASE_URL + "/admin/getAllCourses",
};

// COURSE ENDPOINTS
export const courseEndpoints = {
  GET_ALL_COURSE_API: BASE_URL + "/course/getAllCourses",
  COURSE_DETAILS_API: BASE_URL + "/course/getCourseDetails",
  EDIT_COURSE_API: BASE_URL + "/course/editCourse",
  COURSE_CATEGORIES_API: BASE_URL + "/course/showAllCategories",
  CREATE_COURSE_API: BASE_URL + "/course/createCourse",
  CREATE_SECTION_API: BASE_URL + "/course/addSection",
  CREATE_SUBSECTION_API: BASE_URL + "/course/addSubSection",
  UPDATE_SECTION_API: BASE_URL + "/course/updateSection",
  UPDATE_SUBSECTION_API: BASE_URL + "/course/updateSubSection",
  GET_ALL_INSTRUCTOR_COURSES_API: BASE_URL + "/course/getInstructorCourses",
  DELETE_SECTION_API: BASE_URL + "/course/deleteSection",
  REORDER_SECTIONS_API: BASE_URL + "/course/reorderSections",
  REORDER_SUBSECTIONS_API: BASE_URL + "/course/reorderSubSections",
  DELETE_SUBSECTION_API: BASE_URL + "/course/deleteSubSection",
  DELETE_COURSE_API: BASE_URL + "/course/deleteCourse",
  GET_FULL_COURSE_DETAILS_AUTHENTICATED:
    BASE_URL + "/course/getFullCourseDetails",
  LECTURE_COMPLETION_API:      BASE_URL + "/course/updateCourseProgress",
  SUBMIT_IN_COURSE_QUIZ_API:   BASE_URL + "/course/submitInCourseQuiz",
  GET_LECTURE_NOTE_API:  (id) => BASE_URL + `/course/note/${id}`,
  SAVE_LECTURE_NOTE_API: (id) => BASE_URL + `/course/note/${id}`,
  CREATE_RATING_API:           BASE_URL + "/course/createRating",
};

// RATINGS AND REVIEWS
export const ratingsEndpoints = {
  REVIEWS_DETAILS_API: BASE_URL + "/course/getReviews",
};

// CATAGORIES API
export const categories = {
  CATEGORIES_API: BASE_URL + "/course/showAllCategories",
};

// CATALOG PAGE DATA
export const catalogData = {
  CATALOGPAGEDATA_API: BASE_URL + "/course/getCategoryPageDetails",
};
// CONTACT-US API
export const contactusEndpoint = {
  CONTACT_US_API: BASE_URL + "/reach/contact",
};

// ASSESSMENT & CERTIFICATE ENDPOINTS
export const assessmentEndpoints = {
  CHECK_ELIGIBILITY_API:  (id) => BASE_URL + `/assessment/eligibility/${id}`,
  GET_ASSESSMENT_API:     (id) => BASE_URL + `/assessment/info/${id}`,
  GET_ATTEMPT_API:        (id) => BASE_URL + `/assessment/attempt/${id}`,
  SUBMIT_MCQ_API:         (id) => BASE_URL + `/assessment/submit-mcq/${id}`,
  SUBMIT_CODE_API:        (id) => BASE_URL + `/assessment/submit-code/${id}`,
  SUBMIT_PROJECT_API:     (id) => BASE_URL + `/assessment/submit-project/${id}`,
  GET_CERTIFICATES_API:         BASE_URL + "/assessment/certificates",
  GET_CERTIFICATE_API:    (id) => BASE_URL + `/assessment/certificate/${id}`,
  VERIFY_CERTIFICATE_API: (id) => BASE_URL + `/assessment/verify/${id}`,
  CREATE_ASSESSMENT_API:            (id) => BASE_URL + `/assessment/create/${id}`,
  ADMIN_CREATE_ASSESSMENT_API:      (id) => BASE_URL + `/assessment/admin-create/${id}`,
  GET_INSTRUCTOR_ASSESSMENT_API:    (id) => BASE_URL + `/assessment/instructor/${id}`,
  GET_ADMIN_ASSESSMENT_API:         (id) => BASE_URL + `/assessment/admin/${id}`,
};

// SETTINGS PAGE API
export const settingsEndpoints = {
  UPDATE_DISPLAY_PICTURE_API: BASE_URL + "/profile/updateDisplayPicture",
  UPDATE_PROFILE_API: BASE_URL + "/profile/updateProfile",
  CHANGE_PASSWORD_API: BASE_URL + "/auth/changepassword",
  DELETE_PROFILE_API: BASE_URL + "/profile/deleteProfile",
};
